module.exports = __webpack_public_path__ + "static/media/pragyan_logo.7dbc6ffc.png";